import React from "react";
import { ICell } from "../interfaces";

export default function Cell(props: ICell) {
  return <>{props.children}</>;
}
